import {TodoStore} from "./TodoStore";
import {Todo} from "./api";

export class LocalTodoStore implements TodoStore{
  async getTodos(_user_id: number): Promise<Todo[]> {
    const data = localStorage.getItem("list");
    if (data) {
      const parsed = JSON.parse(data);
      console.log(parsed);
      return parsed;
    }
    return [];
  }

  async addTodo(todoDescription: string): Promise<Todo> {
    const todos = await this.getTodos(0);
    let next_id: number = Number.parseInt(localStorage.getItem("next_id") || "0");

    const todoId:number = next_id;
    next_id += 1;
    localStorage.setItem("next_id", next_id+"");
    const todo: Todo = {
      id: todoId,
      content: todoDescription,
      isDone: false,
    };
    todos.push(todo);
    this._saveTodos(todos);

    return todo;
  }

  _saveTodos(todos: Todo[]) {
    localStorage.setItem("list", JSON.stringify(todos));
  }

  async updateTodo(todoId: number, content?: string, isDone?: boolean) {
    const todos = await this.getTodos(0);
    for (const item of todos) {
      if (item.id === todoId) {
        if(content){
          item.content = content
        }
        if(isDone !== undefined){
          item.isDone = isDone;
        }
        this._saveTodos(todos);
        return item;
      }
    }
  }

  async remove(todoId: number) {
    const todos = await this.getTodos(0);
    const done = todos.filter((item) => todoId !== item.id);
    this._saveTodos(done);
  }

  async remove_all() {
    localStorage.removeItem("list");
  }
}
